import { IconProps } from "@/core/global-data/dataInterface.data";


const ArrowIcon = ({ width = '24', height = '24', className = '' }: IconProps) => {
    return (
        <span className={className}>
            <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.99984 19.84L16.5198 13.32C17.2898 12.55 17.2898 11.29 16.5198 10.52L9.99984 4.00004M6 19.84L12.52 13.32C13.29 12.55 13.29 11.29 12.52 10.52L6 4"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    );
};

export default ArrowIcon;
